import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from '@azure/msal-react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import baseConfig from '../../../config/config';
import { getUniqueParam } from "../../components/helpers";

const MicrosoftLogin2 = (props) => {
  const location = useLocation();
  const [href, setHref] = useState("")
  const [userName, setUserName] = useState("");
  const [loginAttempted, setLoginAttempted] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const { instance, inProgress, accounts } = useMsal();

  const fetchCSRFToken = async () => {
    try {
      const csrfResponse = await axios.get(
        baseConfig.apiBaseUrl + '/Utility/GetCSRFToken',
        {
          withCredentials: true,
          headers: {
            "serviceid": sessionStorage.getItem("userToken") || ''
          }
        }
      );
      let csrfToken = csrfResponse?.data?.csrfToken || csrfResponse?.data;
      if (csrfToken) {
        const tokenValue = typeof csrfToken === 'string' ? csrfToken : csrfToken.token;
        localStorage.setItem('csrfToken', tokenValue);
        return tokenValue;
      } else {
        console.error("CSRF token not found in response");
        return null;
      }
    } catch (error) {
      console.error("Failed to fetch CSRF token:", error);
      return null;
    }
  };

  const checkAuthorization = async (email, userName) => {
    const postData = {
      email: email,
    };
    try {
      
      let csrfToken = localStorage.getItem('csrfToken');
      const response = await axios.post(
        baseConfig.apiBaseUrl + "/utility/user/isallowed",
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            "serviceid": sessionStorage.getItem("userToken"),
            "X-CSRF-Token": csrfToken
          },
          withCredentials: true,
          validateStatus: () => true
        }
      );
      if (response.status === 200) {
        const uniqueParam = getUniqueParam();
        navigate({
          pathname: "/Home",
          search: `?visit=${uniqueParam}`,
        });
      } else {
        console.error("Authorization check failed with status:", response.status);
        navigate("/errorPage");
      }
    } catch (error) {
      console.error("API Error:", error);
      navigate("/errorPage");
    }
  };

  const getAndSetRoles = async () => {

    try {
      let csrfToken = localStorage.getItem('csrfToken');

      const response = await axios.post(
        baseConfig.apiBaseUrl + `/utility/user/get/roles`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "serviceid": sessionStorage.getItem("userToken"),
            "X-CSRF-Token": csrfToken
          },
          withCredentials: true,
          validateStatus: () => true
        }
      );

      if (response.status === 200) {
        return response;
      } else {
        console.error("Get roles failed with status:", response.status);
        return "";
      }
    } catch (error) {
      console.error("Get roles error:", error);
      return "";
    }
  };
  const processSuccessfulLogin = async (authResponse) => {
    try {
      const email = authResponse.account.idTokenClaims.email;
      const username = authResponse.account.name;
      if (baseConfig.allowedDomains.some(domain => email.includes(domain))) {
        const accountId = authResponse.account.localAccountId;
        const accessToken = authResponse.accessToken;   
        setUserName(username);
        sessionStorage.setItem("userName", username);
        sessionStorage.setItem("Emailid", email);
        sessionStorage.setItem("accountId", accountId);
        sessionStorage.setItem("userToken", accessToken);
        let csrfToken = await fetchCSRFToken();
        if (!csrfToken) {
          console.error("Failed to fetch CSRF token");
          sessionStorage.clear();
          navigate("/errorPage");
          return;
        }
        const response = await getAndSetRoles();
        if (response === "") {
          sessionStorage.clear();
          navigate("/errorPage");
        } else {
          const rolesString = response.data;
          const rolesList = rolesString.split(',').map(role => role.trim());
          sessionStorage.setItem('AvailableRoles', rolesString);
          sessionStorage.setItem('hasMultipleRoles', rolesList.length > 1 ? 'true' : 'false');
          const activeRole = rolesList[0];
          sessionStorage.setItem('ActiveRole', activeRole);
          
          if (activeRole.includes('EarlyAccess')) {
            sessionStorage.setItem("tab", "3");
            sessionStorage.setItem("selectedMenu", "earlyAccessPreview");
          }else {
            sessionStorage.setItem("selectedMenu", "capacityRoadMap");
            sessionStorage.setItem("tab", "0");
          }
          if (sessionStorage.getItem("href")) {
            window.location.replace(sessionStorage.getItem("href"));
            sessionStorage.removeItem("href");
          } else {
            checkAuthorization(email, username);
          }
        }
      } else {
        sessionStorage.clear();
        navigate("/errorPage");
      }
    } catch (error) {
      console.error("Error processing login:", error);
      sessionStorage.clear();
      navigate("/errorPage");
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem("userName") && sessionStorage.getItem("Emailid")) {
      checkAuthorization(sessionStorage.getItem("Emailid"), sessionStorage.getItem("userName"));
    }
  }, []);

  useEffect(() => {
    const doLogin = async () => {
      if (isProcessing) return;
      
      try {
        setIsProcessing(true);
        const redirectResponse = await instance.handleRedirectPromise();
        
        if (redirectResponse && redirectResponse.account) {
          await processSuccessfulLogin(redirectResponse);
          return;
        }
        const currentAccounts = accounts || instance.getAllAccounts();
        if (currentAccounts && currentAccounts.length > 0) {
          try {
            const silentRequest = {
              scopes: ["User.Read", "openid", "profile", "offline_access", "email", "User.ReadBasic.All"],
              account: currentAccounts[0]
            };
            const silentResponse = await instance.acquireTokenSilent(silentRequest);
            await processSuccessfulLogin(silentResponse);
            return;
          } catch (silentError) {
            console.log("Silent login failed, will attempt interactive login");
          }
        }
        if (!loginAttempted && inProgress === InteractionStatus.None) {
          setLoginAttempted(true);
          signIn();
        }
      } catch (error) {
        console.error("Login error:", error);
        sessionStorage.clear();
        navigate("/errorPage");
      } finally {
        setIsProcessing(false);
      }
    };
    if (inProgress !== InteractionStatus.Startup) {
      doLogin();
    }
  }, [inProgress, accounts, loginAttempted, isProcessing]);

  function signIn() {
    const loginScope = {
      scopes: ["User.Read", "openid", "profile", "offline_access", "email", "User.ReadBasic.All"],
      state: window.location.origin
    };
    instance.loginRedirect(loginScope);
  }

  return (
    <div className="loader-container" style={{ height: "100vh" }}>
      <div className="loader"></div>
    </div>
  );
};

export default MicrosoftLogin2;
